import type { HomeResponse } from './api';

let home: HomeResponse | null = null;
let request: Promise<HomeResponse> | null = null;

/** Last successful homepage read for this SPA document. */
export function cachedHome(): HomeResponse | null {
  return home;
}

/** Seed the document cache from SSR or a completed live read. */
export function cacheHome(value: HomeResponse): void {
  home = value;
}

/**
 * One shared homepage read for navigation prefetch and page refreshes.
 *
 * The response remains visible while a later read refreshes it. Sharing the
 * in-flight promise also means a hover/focus prefetch and the navigation it
 * triggers never issue the same request twice.
 */
export function loadHome(load: () => Promise<HomeResponse>): Promise<HomeResponse> {
  if (request) return request;
  request = load()
    .then((value) => {
      cacheHome(value);
      return value;
    })
    .finally(() => {
      request = null;
    });
  return request;
}

export function resetHomeCacheForTests(): void {
  home = null;
  request = null;
}
